import React, { Component } from 'react';
import ProjectCard from './ProjectCard';
export default class Porfolio extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="portfolio">
        <div>
              <br/>
              <h1>PROJECTS</h1>
        </div>
          {
            resumeData.portfolio && resumeData.portfolio.map((item)=>{
              return(
                <ProjectCard key={item.name} {...item}/>
              )
            })
          }
  </section>
        );
  }
}